<div class="detalhes-dialog">
  <div class="detalhes-dialog__header">
    <div class="detalhes-dialog__title-wrapper">
      <mat-icon>fact_check</mat-icon>
      <h2 mat-dialog-title>
        Inspeção Nº {{ inspecao?.NumeroInspecao }}
      </h2>
    </div>

    <button mat-icon-button mat-dialog-close class="detalhes-dialog__close" aria-label="Fechar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="detalhes-dialog__content">
    <app-ellipsis-animation class="loading" *ngIf="loading && !inspecao"></app-ellipsis-animation>

    <mat-tab-group *ngIf="inspecao" animationDuration="200ms">
      <mat-tab label="Visão Geral">
        <div class="tab-content">
          <section class="info-section">
            <h3 class="section-title">
              <mat-icon>info</mat-icon> Dados da Inspeção
            </h3>
            <div class="grid-info">
              <div class="info-card">
                <span class="info-label">Nº Inspeção</span>
                <span class="info-value">{{ inspecao.NumeroInspecao }}</span>
              </div>
              <div class="info-card">
                <span class="info-label">Categoria</span>
                <span class="info-value">{{ inspecao.TipoInspecaoChecklist?.Descricao || '-' }}</span>
              </div>
              <div class="info-card">
                <span class="info-label">Data da Inspeção</span>
                <span class="info-value">{{ formatDate(inspecao.InseridoEm) }}</span>
              </div>
              <div class="info-card">
                <span class="info-label">Empresa</span>
                <span class="info-value" [title]="inspecao.Empresa?.Pessoa?.RazaoSocial || ''">{{ inspecao.Empresa?.Pessoa?.RazaoSocial || '-' }}</span>
              </div>
              <div class="info-card">
                <span class="info-label">Nº Contrato</span>
                <span class="info-value">{{ inspecao.Contrato?.NumeroContrato || '-' }}</span>
              </div>
              <div class="info-card">
                <span class="info-label">Cliente</span>
                <span class="info-value" [title]="inspecao.Contrato?.Cliente?.Pessoa?.RazaoSocial || ''">{{ inspecao.Contrato?.Cliente?.Pessoa?.RazaoSocial || '-' }}</span>
              </div>
            </div>
          </section>

          <section class="info-section">
            <h3 class="section-title">
              <mat-icon>directions_car</mat-icon> Veículo & Medições
            </h3>
            <div class="grid-info">
              <div class="info-card">
                <span class="info-label">Placa</span>
                <span class="info-value">{{ inspecao.Veiculo?.Placa || inspecao.placa || '-' }}</span>
              </div>
              <div class="info-card">
                <span class="info-label">Status do Veículo</span>
                <span class="info-value">{{ inspecao.VeiculoStatus?.Descricao || inspecao.veiculoStatus || '-' }}</span>
              </div>
              <div class="info-card">
                <span class="info-label">Hodômetro</span>
                <span class="info-value">{{ (inspecao.Hodometro !== undefined ? inspecao.Hodometro : inspecao.Veiculo?.Hodometro) }} km</span>
              </div>
              <div class="info-card">
                <span class="info-label">Nível de Combustível</span>
                <span class="info-value">{{ formatNivelCombustivel(inspecao.NivelCombustivel !== undefined ? inspecao.NivelCombustivel : inspecao.Veiculo?.NivelCombustivel) }}</span>
              </div>
            </div>

            <div class="observacoes-card" *ngIf="inspecao.Observacoes">
              <span class="info-label">Observações</span>
              <p class="observacoes-text">{{ inspecao.Observacoes }}</p>
            </div>
          </section>
        </div>
      </mat-tab>

      <mat-tab label="Itens de Checagem ({{ inspecao.ItensChecagem?.length || 0 }})">
        <div class="tab-content">
          <section class="info-section">
            <h3 class="section-title">
              <mat-icon>checklist</mat-icon> Verificação de Componentes
            </h3>

            <div class="checklist-grid" *ngIf="inspecao.ItensChecagem && inspecao.ItensChecagem.length > 0">
              <div class="checklist-item" *ngFor="let item of inspecao.ItensChecagem"
                [class.checked]="item.Checado === 'S'">
                <div class="checklist-item__info">
                  <mat-icon>{{ item.Checado === 'S' ? 'check_circle' : 'cancel' }}</mat-icon>
                  <span>{{ item.ItemChecagemChecklist?.Descricao || 'Item #' + item.CodigoItem }}</span>
                </div>
                <span class="badge" [class.badge--success]="item.Checado === 'S'">
                  {{ item.Checado === 'S' ? 'Checado' : 'Não Checado' }}
                </span>
              </div>
            </div>
          </section>
        </div>
      </mat-tab>

      <mat-tab label="Pneus">
        <div class="tab-content">
          <section class="info-section" *ngIf="inspecao.Pneus">
            <h3 class="section-title">
              <mat-icon>album</mat-icon> Condição dos Pneus
            </h3>

            <div class="pneus-grid">
              <div class="pneu-card">
                <div class="pneu-card__header">
                  <mat-icon>radio_button_checked</mat-icon>
                  <h4>Dianteiro Esquerdo</h4>
                </div>
                <div class="pneu-card__content">
                  <div class="pneu-stat">
                    <span>Conservação</span>
                    <span class="percent">{{ inspecao.Pneus.PercentualPneuDianteiroEsquerdo || 0 }}%</span>
                  </div>
                  <div class="pneu-stat">
                    <span>Marcado</span>
                    <span>{{ inspecao.Pneus.PneuDianteiroEsquerdoMarcado === 'S' ? 'Sim' : 'Não' }}</span>
                  </div>
                  <div class="pneu-stat">
                    <span>Calota</span>
                    <span>{{ inspecao.Pneus.PneuDianteiroEsquerdoCalota === 'S' ? 'Sim' : 'Não' }}</span>
                  </div>
                </div>
              </div>

              <div class="pneu-card">
                <div class="pneu-card__header">
                  <mat-icon>radio_button_checked</mat-icon>
                  <h4>Dianteiro Direito</h4>
                </div>
                <div class="pneu-card__content">
                  <div class="pneu-stat">
                    <span>Conservação</span>
                    <span class="percent">{{ inspecao.Pneus.PercentualPneuDianteiroDireito || 0 }}%</span>
                  </div>
                  <div class="pneu-stat">
                    <span>Marcado</span>
                    <span>{{ inspecao.Pneus.PneuDianteiroDireitoMarcado === 'S' ? 'Sim' : 'Não' }}</span>
                  </div>
                  <div class="pneu-stat">
                    <span>Calota</span>
                    <span>{{ inspecao.Pneus.PneuDianteiroDireitoCalota === 'S' ? 'Sim' : 'Não' }}</span>
                  </div>
                </div>
              </div>

              <div class="pneu-card">
                <div class="pneu-card__header">
                  <mat-icon>radio_button_checked</mat-icon>
                  <h4>Traseiro Esquerdo</h4>
                </div>
                <div class="pneu-card__content">
                  <div class="pneu-stat">
                    <span>Conservação</span>
                    <span class="percent">{{ inspecao.Pneus.PercentualPneuTraseiroEsquerdo || 0 }}%</span>
                  </div>
                  <div class="pneu-stat">
                    <span>Marcado</span>
                    <span>{{ inspecao.Pneus.PneuTraseiroEsquerdoMarcado === 'S' ? 'Sim' : 'Não' }}</span>
                  </div>
                  <div class="pneu-stat">
                    <span>Calota</span>
                    <span>{{ inspecao.Pneus.PneuTraseiroEsquerdoCalota === 'S' ? 'Sim' : 'Não' }}</span>
                  </div>
                </div>
              </div>

              <div class="pneu-card">
                <div class="pneu-card__header">
                  <mat-icon>radio_button_checked</mat-icon>
                  <h4>Traseiro Direito</h4>
                </div>
                <div class="pneu-card__content">
                  <div class="pneu-stat">
                    <span>Conservação</span>
                    <span class="percent">{{ inspecao.Pneus.PercentualPneuTraseiroDireito || 0 }}%</span>
                  </div>
                  <div class="pneu-stat">
                    <span>Marcado</span>
                    <span>{{ inspecao.Pneus.PneuTraseiroDireitoMarcado === 'S' ? 'Sim' : 'Não' }}</span>
                  </div>
                  <div class="pneu-stat">
                    <span>Calota</span>
                    <span>{{ inspecao.Pneus.PneuTraseiroDireitoCalota === 'S' ? 'Sim' : 'Não' }}</span>
                  </div>
                </div>
              </div>

              <div class="pneu-card">
                <div class="pneu-card__header">
                  <mat-icon>radio_button_checked</mat-icon>
                  <h4>Estepe / Reserva</h4>
                </div>
                <div class="pneu-card__content">
                  <div class="pneu-stat">
                    <span>Conservação</span>
                    <span class="percent">{{ inspecao.Pneus.PercentualPneuReserva || 0 }}%</span>
                  </div>
                  <div class="pneu-stat">
                    <span>Marcado</span>
                    <span>{{ inspecao.Pneus.PneuReservaMarcado === 'S' ? 'Sim' : 'Não' }}</span>
                  </div>
                  <div class="pneu-stat">
                    <span>Calota</span>
                    <span>{{ inspecao.Pneus.PneuReservaCalota === 'S' ? 'Sim' : 'Não' }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="observacoes-card" *ngIf="inspecao.Pneus.Comentarios">
              <span class="info-label">Comentários dos Pneus</span>
              <p class="observacoes-text">{{ inspecao.Pneus.Comentarios }}</p>
            </div>
          </section>
        </div>
      </mat-tab>

      <mat-tab label="Serviços & Equipamentos">
        <div class="tab-content">
          <section class="info-section">
            <h3 class="section-title">
              <mat-icon>design_services</mat-icon> Serviços Adicionais
            </h3>

            <div class="checklist-grid"
              *ngIf="inspecao.ItensChecagemServicosAdicionais && inspecao.ItensChecagemServicosAdicionais.length > 0">
              <div class="checklist-item" *ngFor="let s of inspecao.ItensChecagemServicosAdicionais"
                [class.checked]="s.Checado === 'S'">
                <div class="checklist-item__info">
                  <mat-icon>{{ s.Checado === 'S' ? 'check_circle' : 'cancel' }}</mat-icon>
                  <span>{{ s.ServicoAdicional?.Descricao || 'Serviço #' + s.CodigoServicoAdicional }}</span>
                </div>
                <span class="badge" [class.badge--success]="s.Checado === 'S'">
                  {{ s.Checado === 'S' ? 'Checado' : 'Não Checado' }}
                </span>
              </div>
            </div>
          </section>

          <section class="info-section" style="margin-top: 24px;">
            <h3 class="section-title">
              <mat-icon>build</mat-icon> Equipamentos do Veículo
            </h3>

            <div class="equipamentos-grid"
              *ngIf="inspecao.InspecaoEquipamentos && inspecao.InspecaoEquipamentos.length > 0">
              <div class="equipamento-card" *ngFor="let eq of inspecao.InspecaoEquipamentos">
                <div class="equipamento-card__header">
                  <mat-icon>settings</mat-icon>
                  <span>{{ eq.Equipamento?.Descricao || 'Equipamento #' + eq.CodigoEquipamento }}</span>
                </div>
                <div class="tags">
                  <span class="tag" [class.tag--primary]="eq.Serie === 'S'">
                    Série: {{ eq.Serie === 'S' ? 'Sim' : 'Não' }}
                  </span>
                  <span class="tag" [class.tag--info]="eq.Opcional === 'S'">
                    Opcional: {{ eq.Opcional === 'S' ? 'Sim' : 'Não' }}
                  </span>
                  <span class="tag" [class.tag--success]="eq.Existente === 'S'">
                    Existente: {{ eq.Existente === 'S' ? 'Sim' : 'Não' }}
                  </span>
                  <span class="tag" [class.tag--danger]="eq.Avariado === 'S'">
                    Avariado: {{ eq.Avariado === 'S' ? 'Sim' : 'Não' }}
                  </span>
                </div>
              </div>
            </div>
          </section>
        </div>
      </mat-tab>

      <mat-tab label="Assinatura">
        <div class="tab-content">
          <section class="info-section" *ngIf="inspecao.Assinatura">
            <h3 class="section-title">
              <mat-icon>draw</mat-icon> Dados da Assinatura e Recebedor
            </h3>

            <div class="grid-info">
              <div class="info-card">
                <span class="info-label">Nome do Recebedor</span>
                <span class="info-value" [title]="inspecao.Assinatura.NomeRecebedor || ''">{{ inspecao.Assinatura.NomeRecebedor || '-' }}</span>
              </div>
              <div class="info-card">
                <span class="info-label">E-mail do Recebedor</span>
                <span class="info-value" [title]="inspecao.Assinatura.EmailRecebedor || ''">{{ inspecao.Assinatura.EmailRecebedor || '-' }}</span>
              </div>
              <div class="info-card">
                <span class="info-label">Documentos</span>
                <span class="info-value" [title]="inspecao.Assinatura.DocumentosRecebedor || ''">{{ inspecao.Assinatura.DocumentosRecebedor || '-' }}</span>
              </div>
              <div class="info-card">
                <span class="info-label">Data da Assinatura</span>
                <span class="info-value">{{ formatDate(inspecao.Assinatura.InseridoEm) }}</span>
              </div>
            </div>
          </section>

          <div class="empty-state" *ngIf="!inspecao.Assinatura">
            <mat-icon>draw</mat-icon>
            <span>Nenhum dado de assinatura registrado para esta inspeção.</span>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </mat-dialog-content>

  <div mat-dialog-actions align="end">
    <button mat-flat-button color="primary" (click)="close()">
      Fechar
    </button>
  </div>
</div>